module.exports = __webpack_public_path__ + "img/big.2cc42eaf.jpg";